export default __webpack_public_path__ + "static/media/group.ff1a3aa0.png";